import React, { useState } from 'react';
import { Button, Drawer } from '@mui/material';
import CustomList from './CustomList';
import MenuIcon from '@mui/icons-material/Menu';

const LeftMenuMobile = ({ view, setView, surveyToolsAllowed }) => {
  const [leftMenu, setLeftMenu] = useState(false);

  const toggleDrawer = open => {
    return event => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

      setLeftMenu(open);
    };
  };

  return (
    <React.Fragment key={'left'}>
      <Button onClick={toggleDrawer(true)}>
        <MenuIcon />
      </Button>
      <Drawer
        anchor={'left'}
        open={leftMenu}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            borderRadius: '0px 16px 16px 0px',
            backgroundColor: '#F3F3F6',
            justifyContent: 'center',
            padding: 3,
          },
        }}
      >
        <CustomList anchor={'left'} toggleDrawer={toggleDrawer} setView={setView} view={view}
                    surveyToolsAllowed={surveyToolsAllowed} />
      </Drawer>
    </React.Fragment>
  );
};

export default LeftMenuMobile;
